"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OTHER = exports.PENSION_RETIREMENT = exports.DISABILITY = exports.OTHER_GOVERNMENT_ASSISTANCE = exports.VA_DISABILITY = exports.CHIP = exports.LIHEAP = exports.LIFELINE_PHONE = exports.SECTION_8 = exports.TANF = exports.SNAP = exports.SOCIAL_SECURITY_DISABILITY_INSURANCE = exports.SUPPLEMENTAL_SECURITY_INCOME_FOR_CHILDREN = exports.SUPPLEMENTAL_SECURITY_INCOME = exports.SOCIAL_SECURITY = exports.UNEMPLOYMENT = exports.OUTSIDE_CONTRIBUTORS = exports.HOUSEHOLD_CONTRIBUTIONS = exports.ALIMONY = exports.FAMILY_SUPPORT = exports.INTERESTS_DIVIDENDS_ROYALTIES = exports.PROPERTY_RENTAL = exports.BUSINESS_PROFESSIONAL_FARM = exports.SELF_EMPLOYED = exports.INDEPENDENT_CONTRACTOR = exports.EMPLOYEE = void 0; // Employment Sub-Types

var EMPLOYEE = 'employee';
exports.EMPLOYEE = EMPLOYEE;
var INDEPENDENT_CONTRACTOR = 'independentContractor';
exports.INDEPENDENT_CONTRACTOR = INDEPENDENT_CONTRACTOR;
var SELF_EMPLOYED = 'selfEmployed'; // Non-Employment Sub-Types

exports.SELF_EMPLOYED = SELF_EMPLOYED;
var BUSINESS_PROFESSIONAL_FARM = 'businessProfessionalFarm';
exports.BUSINESS_PROFESSIONAL_FARM = BUSINESS_PROFESSIONAL_FARM;
var PROPERTY_RENTAL = 'propertyRental'; // Distinguish rental/Airbnb income for means test

exports.PROPERTY_RENTAL = PROPERTY_RENTAL;
var INTERESTS_DIVIDENDS_ROYALTIES = 'interestsDividendsRoyalties';
exports.INTERESTS_DIVIDENDS_ROYALTIES = INTERESTS_DIVIDENDS_ROYALTIES;
var FAMILY_SUPPORT = 'familySupport';
exports.FAMILY_SUPPORT = FAMILY_SUPPORT;
var ALIMONY = 'alimony'; // Added for surveys

exports.ALIMONY = ALIMONY;
var HOUSEHOLD_CONTRIBUTIONS = 'householdContributions';
exports.HOUSEHOLD_CONTRIBUTIONS = HOUSEHOLD_CONTRIBUTIONS;
var OUTSIDE_CONTRIBUTORS = 'outsideContributors'; // Added for surveys

exports.OUTSIDE_CONTRIBUTORS = OUTSIDE_CONTRIBUTORS;
var UNEMPLOYMENT = 'unemployment';
exports.UNEMPLOYMENT = UNEMPLOYMENT;
var SOCIAL_SECURITY = 'socialSecurity';
exports.SOCIAL_SECURITY = SOCIAL_SECURITY;
var SUPPLEMENTAL_SECURITY_INCOME = 'supplementalSecurityIncome';
exports.SUPPLEMENTAL_SECURITY_INCOME = SUPPLEMENTAL_SECURITY_INCOME;
var SUPPLEMENTAL_SECURITY_INCOME_FOR_CHILDREN = 'supplementalSecurityIncomeForChildren';
exports.SUPPLEMENTAL_SECURITY_INCOME_FOR_CHILDREN = SUPPLEMENTAL_SECURITY_INCOME_FOR_CHILDREN;
var SOCIAL_SECURITY_DISABILITY_INSURANCE = 'socialSecurityDisabilityInsurance';
exports.SOCIAL_SECURITY_DISABILITY_INSURANCE = SOCIAL_SECURITY_DISABILITY_INSURANCE;
var SNAP = 'snap'; // Added for surveys

exports.SNAP = SNAP;
var TANF = 'tanf'; // Added for surveys

exports.TANF = TANF;
var SECTION_8 = 'section8'; // Added for surveys

exports.SECTION_8 = SECTION_8;
var LIFELINE_PHONE = 'lifelinePhone'; // Added for surveys

exports.LIFELINE_PHONE = LIFELINE_PHONE;
var LIHEAP = 'liheap'; // home enegery subsidy

exports.LIHEAP = LIHEAP;
var CHIP = 'chip'; // child insurance/nutrition

exports.CHIP = CHIP;
var VA_DISABILITY = 'vaDisability';
exports.VA_DISABILITY = VA_DISABILITY;
var OTHER_GOVERNMENT_ASSISTANCE = 'otherGovernmentAssistance';
exports.OTHER_GOVERNMENT_ASSISTANCE = OTHER_GOVERNMENT_ASSISTANCE;
var DISABILITY = 'disability'; // Not sure if this is info matters elsewhere besides schedule I non-employment

exports.DISABILITY = DISABILITY;
var PENSION_RETIREMENT = 'pensionRetirement';
exports.PENSION_RETIREMENT = PENSION_RETIREMENT;
var OTHER = 'other';
exports.OTHER = OTHER;